import React from "react";
import { GrTechnology } from "react-icons/gr";

function Skills() {
  return (
    <section id="skills" className="pt-[80px] sm:pt-[120px]">
      <div className="container">
        <h2 className="flex items-center justify-center text-xl sm:text-2xl text-white">
          <span className="inline-block w-14 sm:w-40 h-[1px] bg-[rgba(100,255,218,0.1)] rounded-full mr-5"></span>{" "}
          Skills
          <span className="inline-block ml-2">
            <GrTechnology className="text-lg sm:text-xl bg-white" />
          </span>
          <span className="inline-block w-14 sm:w-40 h-[1px] bg-[rgba(100,255,218,0.1)] rounded-full ml-5"></span>
        </h2>

        <div className="max-w-[700px] mx-auto mt-8 sm:mt-12">
          <p className="text-white text-center"></p>
          <div className="mt-5">
            <p className="text-white text-center">
              Here are a few main technologies I’ve been working with so far:
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 items-start gap-4 md:gap-6 mt-10">
          <div data-aos="fade-up" data-aos-duration="600">
            <div className="flex justify-between mb-1 max-w-[400px] w-full">
              <span className="text-base font-medium text-white dark:text-white">
                HTML
              </span>
              <span className="text-sm font-medium text-white dark:text-white">
                90%
              </span>
            </div>
            <div className="max-w-[400px] w-full bg-gray-300 rounded-full h-2 dark:bg-[#52202d]">
              <div className="bg-blue-700 h-2 rounded-full w-[90%]"></div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-duration="600" data-aos-delay="50">
            <div className="flex justify-between mb-1 max-w-[400px] w-full">
              <span className="text-base font-medium text-white dark:text-white">
                Css
              </span>
              <span className="text-sm font-medium text-white dark:text-white">
                90%
              </span>
            </div>
            <div className="max-w-[400px] w-full bg-gray-300 rounded-full h-2 dark:bg-[#52202d]">
              <div className="bg-blue-700 h-2 rounded-full w-[90%]"></div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-duration="600" data-aos-delay="100">
            <div className="flex justify-between mb-1 max-w-[400px] w-full">
              <span className="text-base font-medium text-white dark:text-white">
                Python
              </span>
              <span className="text-sm font-medium text-white dark:text-white">
                85%
              </span>
            </div>
            <div className="max-w-[400px] w-full bg-gray-300 rounded-full h-2 dark:bg-[#52202d]">
              <div className="bg-blue-700 h-2 rounded-full w-[85%]"></div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-duration="600" data-aos-delay="150">
            <div className="flex justify-between mb-1 max-w-[400px] w-full">
              <span className="text-base font-medium text-white dark:text-white">
                C++
              </span>
              <span className="text-sm font-medium text-white dark:text-white">
                85%
              </span>
            </div>
            <div className="max-w-[400px] w-full bg-gray-300 rounded-full h-2 dark:bg-[#52202d]">
              <div className="bg-blue-700 h-2 rounded-full w-[85%]"></div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-duration="600" data-aos-delay="200">
            <div className="flex justify-between mb-1 max-w-[400px] w-full">
              <span className="text-base font-medium text-white dark:text-white">
                Java
              </span>
              <span className="text-sm font-medium text-white dark:text-white">
                80%
              </span>
            </div>
            <div className="max-w-[400px] w-full bg-gray-300 rounded-full h-2 dark:bg-[#52202d]">
              <div className="bg-blue-700 h-2 rounded-full w-[80%]"></div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-duration="600" data-aos-delay="250">
            <div className="flex justify-between mb-1 max-w-[400px] w-full">
              <span className="text-base font-medium text-white dark:text-white">
                MS Office
              </span>
              <span className="text-sm font-medium text-white dark:text-white">
                98%
              </span>
            </div>
            <div className="max-w-[400px] w-full bg-gray-300 rounded-full h-2 dark:bg-[#52202d]">
              <div className="bg-blue-700 h-2 rounded-full w-[98%]"></div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-duration="600" data-aos-delay="300">
            <div className="flex justify-between mb-1 max-w-[400px] w-full">
              <span className="text-base font-medium text-white dark:text-white">
                Google apps
              </span>
              <span className="text-sm font-medium text-white dark:text-white">
                99%
              </span>
            </div>
            <div className="max-w-[400px] w-full bg-gray-300 rounded-full h-2 dark:bg-[#52202d]">
              <div className="bg-blue-700 h-2 rounded-full w-[99%]"></div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-duration="600" data-aos-delay="350">
            <div className="flex justify-between mb-1 max-w-[400px] w-full">
              <span className="text-base font-medium text-white dark:text-white">
                Communication
              </span>
              <span className="text-sm font-medium text-white dark:text-white">
                95%
              </span>
            </div>
            <div className="max-w-[400px] w-full bg-gray-300 rounded-full h-2 dark:bg-[#52202d]">
              <div className="bg-blue-700 h-2 rounded-full w-[95%]"></div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-duration="600" data-aos-delay="400">
            <div className="flex justify-between mb-1 max-w-[400px] w-full">
              <span className="text-base font-medium text-white dark:text-white">
                Teaching and consulting
              </span>
              <span className="text-sm font-medium text-white dark:text-white">
                99%
              </span>
            </div>
            <div className="max-w-[400px] w-full bg-gray-300 rounded-full h-2 dark:bg-[#52202d]">
              <div className="bg-blue-700 h-2 rounded-full w-[99%]"></div>
            </div>
          </div>
          <div data-aos="fade-up" data-aos-duration="600" data-aos-delay="450">
            <div className="flex justify-between mb-1 max-w-[400px] w-full">
              <span className="text-base font-medium text-white dark:text-white">
                Critical and Logical Thinking
              </span>
              <span className="text-sm font-medium text-white dark:text-white">
                97%
              </span>
            </div>
            <div className="max-w-[400px] w-full bg-gray-300 rounded-full h-2 dark:bg-[#52202d]">
              <div className="bg-blue-700 h-2 rounded-full w-[97%]"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Skills;
